const management = [
  { id: 1, job: 'エンジニアマネージャー' },
  { id: 2, job: 'テックリード' },
  { id: 3, job: 'プロジェクトマネージャー' },
  { id: 4, job: 'プロダクトマネージャー' },
  { id: 5, job: 'PMO' },
  { id: 6, job: 'VPoE' },
  { id: 7, job: 'CTO' },
  { id: 8, job: 'CIO' },
  { id: 9, job: 'スクラムマスター' }
] as const;

const consultingAndPlanning = [
  { id: 10, job: 'ITコンサルタント' },
  { id: 11, job: 'セキュリティコンサルタント' },
  { id: 12, job: 'IT企画' }
] as const;

const development = [
  { id: 13, job: 'バックエンドエンジニア' },
  { id: 14, job: 'フロントエンドエンジニア' },
  { id: 15, job: 'フルスタックエンジニア' },
  { id: 16, job: 'モバイルエンジニア' },
  { id: 17, job: 'プロダクトエンジニア' },
  // システムエンジニアはシナリオでは利用するが、職種として入力しないためコメントアウト
  // { id: 18, job: 'システムエンジニア' },
  { id: 19, job: 'SE（アプリ）' },
  { id: 20, job: 'SE（インフラ）' },
  { id: 21, job: '社内SE' },
  { id: 22, job: 'ゲームエンジニア' },
  { id: 23, job: '制御・組み込みエンジニア' }
] as const;

const infrastructure = [
  { id: 24, job: 'インフラエンジニア' },
  { id: 25, job: 'セキュリティエンジニア' },
  { id: 26, job: 'ネットワークエンジニア' },
  { id: 27, job: 'データベースエンジニア' }
] as const;

const data = [
  { id: 28, job: 'データエンジニア' },
  { id: 29, job: '機械学習エンジニア' },
  { id: 30, job: 'データサイエンティスト' }
] as const;

const operationAndPlatform = [
  { id: 31, job: 'SRE' },
  { id: 32, job: 'DevOpsエンジニア' },
  { id: 33, job: 'QA' }
] as const;

const customerSupport = [
  { id: 34, job: 'テクニカルサポート' },
  { id: 35, job: 'カスタマーサクセス' }
] as const;

const salesAndPublicRelations = [
  { id: 36, job: 'プリセールス' },
  { id: 37, job: '技術広報' }
] as const;

const other = [
  { id: 38, job: 'その他エンジニア' },
  { id: 39, job: 'その他コンサル' },
  { id: 40, job: '営業' },
  { id: 41, job: 'マーケティング' },
  { id: 42, job: '販売 ・事務' },
  { id: 43, job: '公務員' },
  { id: 44, job: '医療・福祉' },
  { id: 45, job: '保安' },
  { id: 46, job: '教育・保育' },
  { id: 47, job: 'サービス' },
  { id: 48, job: '経営' },
  { id: 49, job: 'その他' }
] as const;

export const jobExperienceList = [
  {
    categoryKey: 'management',
    categoryName: 'マネジメント',
    list: management
  },
  {
    categoryKey: 'consultingAndPlanning',
    categoryName: 'コンサル・企画',
    list: consultingAndPlanning
  },
  {
    categoryKey: 'development',
    categoryName: '開発',
    list: development
  },
  {
    categoryKey: 'infrastructure',
    categoryName: 'インフラ',
    list: infrastructure
  },
  {
    categoryKey: 'data',
    categoryName: 'データ',
    list: data
  },
  {
    categoryKey: 'operationAndPlatform',
    categoryName: '運用・基盤',
    list: operationAndPlatform
  },
  {
    categoryKey: 'customerSupport',
    categoryName: 'カスタマーサポート',
    list: customerSupport
  },
  {
    categoryKey: 'salesAndPublicRelations',
    categoryName: 'セールス・広報',
    list: salesAndPublicRelations
  },
  {
    categoryKey: 'other',
    categoryName: 'その他',
    list: other
  }
] as const;
